export class Urls {
    static api = "/api/respondent/survey-assignment/"

    static surveyAssignment = (accessCode: string) => `${Urls.api}${accessCode}/`

    static submitSurvey = (accessCode?: string) => `${Urls.api}${accessCode}/submit/`
}
